import axios from 'axios';

// "http://localhost:3333"
// "https://api.meupedidogo.com.br"
const url = "https://api.meupedidogo.com.br";

export const api = axios.create({
    baseURL: url,
});

// Authentication
export const registrar = async (usuario, email, senha, confirmacaoSenha) => { 
     return api.post('/registrar', {usuario, email, senha, confirmacaoSenha})
        .then((response) => response)
        .catch((error) => error.response.data); 
};    

export const createSession = async (usuario, senha) => {
    return api.post('/login', {usuario, senha})
        .then((response) => response)
        .catch((error) => error.response.data)
}
export const reiniciarToken = async() => {
    return api.post('/refreshtoken')
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Usuário
export const visualizarUsuario = async(usuario) => {
    return api.get(`/usuarios/visualizar/${usuario}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consUsuario = async => {
    return api.get('/usuarios/consultar')
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consUsuariosEmpresa = async => {
    return api.get('/usuarios_empresa/consultar', {
        params: {id_empresa: localStorage.getItem(['id_empresa'])}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarUsuario = async(usuario, dados) => {
    return api.post(`/usuarios/editar/${usuario}`, dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Clientes
export const visualizarClientes = async (id) => {
    return api.get(`/clientes/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaClientes = async() => {
    return api.get('/clientes/consultar', {
        params: {usuario: localStorage.getItem(['usuario']), id_empresa: localStorage.getItem(['id_empresa'])}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaSelectClientes = () => {
    return api.get('/clientes/consultar')
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const cadastrarClientes = async(dados) => {
    return api.post('/clientes/cadastrar',dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarClientes = async(id, dados) => {
    return api.post(`/clientes/editar/${id}`, dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const excluirClientes = async(id) => {
    return api.delete(`/clientes/excluir/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data)
}
export const consClienteConsumidorPadrao = async() => {
    return api.get('/clientes/consumidor_padrao', {
        params: {usuario: localStorage.getItem(['usuario']), id_empresa: localStorage.getItem(['id_empresa'])}
    })
        .then((response) => response)
        .catch((error) => error.response.data)
}

// Fornecedores
export const visualizarFornecedores = async(id) => {
    return api.get(`/fornecedores/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaFornecedores = async() => {
    return api.get('/fornecedores/consultar',{
        params: {usuario: localStorage.getItem(['usuario']), id_empresa: localStorage.getItem(['id_empresa'])}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const cadastrarFornecedores = async(dados) => {
    return api.post('/fornecedores/cadastrar', dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarFornecedores = async(id, dados) => {
    return api.post(`/fornecedores/editar/${id}`, dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const excluirFornecedores = async(id) => {
    return api.delete(`/fornecedores/excluir/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Produtos
export const visualizarProdutos = async(id) => {
    return api.get(`/produtos/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaProdutos = async() => {
    return api.get('/produtos/consultar',{
        params: {usuario: localStorage.getItem(['usuario']), id_empresa: localStorage.getItem(['id_empresa'])}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaProdutosFiltro = async(descricaoParametro, movimentaEstoque) => {
    return api.get('/produtos/consultar_por_filtro',{
        params: {
            usuario: localStorage.getItem(['usuario']), 
            id_empresa: localStorage.getItem(['id_empresa']),
            descricao: descricaoParametro,
            movimenta_estoque: movimentaEstoque
        }
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const cadastrarProdutos = async(dados) => {
    return api.post('/produtos/cadastrar',dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarProdutos = async(id, dados) => {
    return api.post(`/produtos/editar/${id}`, dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const excluirProdutos = async(id) => {
    return api.delete(`/produtos/excluir/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const atualizarEstoqueProduto = async(id, dados) => {
    return api.post(`/produtos/atualizar_estoque/${id}`, dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaProdutoCodigoBarra = async(id) => {
    return api.get(`/produtos/consulta_codigo_barra/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Imagem Produto
export const consImagensProduto = async(id) => {
    return api.get(`/imagem_produto/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Vendas
export const visualizarVendas = async(id) => {
    return api.get(`/vendas/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaVendas = async(dataInicio, dataFim, formaPagamento, usuarioConsulta, statusViagemConsulta) => {
    return api.get('/vendas/consultar', {
        params: {usuario: localStorage.getItem(['usuario']), 
                 id_empresa: localStorage.getItem(['id_empresa']),
                 dataInicial: dataInicio, 
                 dataFinal: dataFim,
                 forma_pagamento: formaPagamento,
                 usuarioParam: usuarioConsulta,
                 statusViagem: statusViagemConsulta}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const cadastrarVendas = async(dados) => {
    return api.post('/vendas/cadastrar',dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarVendas = async(id, dados) => {
    return api.post(`/vendas/editar/${id}`, dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const excluirVendas = async(id) => {
    return api.delete(`/vendas/excluir/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const totalVendas = async(dataInicio, dataFim) => {
    return api.get('/vendas/total_venda', {
        params: {usuario: localStorage.getItem(['usuario']), 
                 id_empresa: localStorage.getItem(['id_empresa']), 
                 dataInicial: dataInicio, 
                 dataFinal: dataFim}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const totalVendasAno = async => {
    return api.get('/vendas/total_venda_ano', {
        params: {usuario: localStorage.getItem(['usuario']), id_empresa: localStorage.getItem(['id_empresa'])}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const totalVendasProdutosMes = async(dataInicio, dataFim) => {
    return api.get('/vendas/total_venda_produto_mes', {
        params: {
            usuario: localStorage.getItem(['usuario']), 
            id_empresa: localStorage.getItem(['id_empresa']),
            dataInicial: dataInicio, 
            dataFinal: dataFim}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const atualizarSituacaoVenda = async(id, dados) => {
    return api.post(`/vendas/atualiza_situacao/${id}`, dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Vendas por Mesa
export const visualizarVendasMesa = async(id) => {
    return api.get(`/item_venda/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaVendasMesa = async(id) => {
    return api.get('/item_venda/consultar', {
        params: {usuario: localStorage.getItem(['usuario']), id_empresa: localStorage.getItem(['id_empresa']), id_mesa: id}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const cadastrarVendasMesa = async(dados) => {
    return api.post('/item_venda/cadastrar',dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarVendasMesa = async(id, dados) => {
    return api.post(`/item_venda/editar/${id}`, dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const excluirVendasMesa = async(id) => {
    return api.delete(`/item_venda/excluir/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const totalVendasMesa = async(id) => {
    return api.get('/item_venda/total_venda_mesa', {
        params: {usuario: localStorage.getItem(['usuario']), id_empresa: localStorage.getItem(['id_empresa']), id_mesa: id}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const finalizaVendasMesa = async(id, idVenda, valorPagamento) => {
    return api.get('/item_venda/finaliza_venda_mesa', {
        params: {id_empresa: localStorage.getItem(['id_empresa']), id_mesa: id, id_venda: idVenda, valor_pagamento: valorPagamento}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const atualizarQuantidadeItens = async(id, dados) => {
    return api.post(`/item_venda/atualizar_quantidade/${id}`, dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Vendas Avulsas
export const consultaVendasAvulsa = async(usuarioParam) => {
    return api.get('/item_venda/consultar/venda_avulsa', {
        params: {usuario: usuarioParam, id_empresa: localStorage.getItem(['id_empresa'])}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const finalizaVendasAvulsa = async(idVenda, valorPagamento, usuarioParam) => {
    return api.get('/item_venda/finaliza_venda_avulsa', {
        params: {usuario: usuarioParam, id_empresa: localStorage.getItem(['id_empresa']), id_venda: idVenda, valor_pagamento: valorPagamento}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consItemVendaFinalizada = async(id) => {
    return api.get(`/item_venda/consultar/venda_avulsa_geral/${id}`, {
        params: {usuario: localStorage.getItem(['usuario']), id_empresa: localStorage.getItem(['id_empresa'])}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Despesas
export const visualizarDespesas = async(id) => {
    return api.get(`/despesas/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaDespesas = async(dataInicio, dataFim, idTipoDespesa) => {
    return api.get('/despesas/consultar', {
        params: {usuario: localStorage.getItem(['usuario']), 
                 id_empresa: localStorage.getItem(['id_empresa']),
                 dataInicial: dataInicio, 
                 dataFinal: dataFim,
                 id_tipo_despesa: idTipoDespesa}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaDespesasVendas = async(id) => {
    return api.get(`/despesas/consulta_despesa_venda/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const cadastrarDespesas = async(dados) => {
    return api.post('/despesas/cadastrar',dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarDespesas = async(id, dados) => {
    return api.post(`/despesas/editar/${id}`,dados)
        .then((response) => response)
        .catch((error) => error.response.data)
}
export const excluirDespesas = async(id) => {
    return api.delete(`/despesas/excluir/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const totalDespesas = async(dataInicio, dataFim) => {
    return api.get('/despesas/total_despesa', {
        params: {usuario: localStorage.getItem(['usuario']), 
                 id_empresa: localStorage.getItem(['id_empresa']),
                 dataInicial: dataInicio, 
                 dataFinal: dataFim}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaTotalDespesaVenda = async(id) => {
    return api.get(`/despesas/total_despesas/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Tipo Despesas
export const visualizarTipoDespesas = async(id) => {
    return api.get(`/tipo_despesas/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consultaTipoDespesas = async(dataInicio, dataFim) => {
    return api.get('/tipo_despesas/consultar', {
        params: {usuario: localStorage.getItem(['usuario']), 
                 id_empresa: localStorage.getItem(['id_empresa']),
                 dataInicial: dataInicio, 
                 dataFinal: dataFim}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const cadastrarTipoDespesas = async(dados) => {
    return api.post('/tipo_despesas/cadastrar',dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarTipoDespesas = async(id, dados) => {
    return api.post(`/tipo_despesas/editar/${id}`,dados)
        .then((response) => response)
        .catch((error) => error.response.data)
}
export const excluirTipoDespesas = async(id) => {
    return api.delete(`/tipo_despesas/excluir/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Mesa
export const visualizarMesa = async(id) => {
    return api.get(`/mesas/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consMesa = async => {
    return api.get('/mesas/consultar', {
        params: {usuario: localStorage.getItem(['usuario']), id_empresa: localStorage.getItem(['id_empresa'])}
        })
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const cadastrarMesa = async(dados) => {
    return api.post('/mesas/cadastrar',dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarMesa = async(id, dados) => {
    return api.post(`/mesas/editar/${id}`,dados)
        .then((response) => response)
        .catch((error) => error.response.data)
}
export const excluirMesa = async(id) => {
    return api.delete(`/mesas/excluir/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Empresa
export const visualizarEmpresa = async(id) => {
    return api.get(`/empresas/visualizar/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const consEmpresa = async => {
    return api.get('/empresas/consultar')
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const cadastrarEmpresa = async(dados) => {
    return api.post('/empresas/cadastrar',dados)
        .then((response) => response)
        .catch((error) => error.response.data);
}
export const editarEmpresa = async(id, dados) => {
    return api.post(`/empresas/editar/${id}`,dados)
        .then((response) => response)
        .catch((error) => error.response.data)
}
export const excluirEmpresa = async(id) => {
    return api.delete(`/empresas/excluir/${id}`)
        .then((response) => response)
        .catch((error) => error.response.data);
}

// Companhia Aerea
export const consultaCompanhiaAerea = async() => {
    return api.get('/companhia_aerea/consultar')
        .then((response) => response)
        .catch((error) => error.response.data);
}